import React, { useState } from 'react';
import { Form, Input, Button, Collapse } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

const { Panel } = Collapse;

const TestCaseForm = ({ LLMs }) => {
  const [form] = Form.useForm();
  const [testcaseName, setTestCaseName] = useState('');
  const [testCaseInput, setTestCaseInput] = useState('');
  const [testCaseOutput, setTestCaseOutput] = useState('');
  const [testCaseAgentId, setTestCaseAgentId] = useState('');
  const [testCaseExecuteProvider, setTestCaseExecuteProvider] = useState('openAI');
  const [testCaseExecuteModel, setTestCaseExecuteModel] = useState('gpt-3.5-turbo');
  const [isModelDropdownVisible, setIsModelDropdownVisible] = useState(false);

  const handleTestCaseModelSelect = (provider, version) => {
    setTestCaseExecuteProvider(provider);
    setTestCaseExecuteModel(version);
  };

  const handleSubmit = () => {
    const payload = {
      testcaseName,
      testCaseInput,
      testCaseOutput,
      testCaseAgentId,
      testCaseExecuteProvider,
      testCaseExecuteModel,
    };
    console.log('Submitted:', payload); // You can replace this with your actual submission logic
    form.resetFields();
  };

  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit} style={{ marginTop: '20px' }}>
      <Form.Item label="Name">
        <Input value={testcaseName} onChange={(e) => setTestCaseName(e.target.value)} />
      </Form.Item>
      <Form.Item label="Input">
        <TextArea rows={2} value={testCaseInput} onChange={(e) => setTestCaseInput(e.target.value)} placeholder="Enter test case input" />
      </Form.Item>
      <Form.Item label="Expected Output">
        <TextArea rows={2} value={testCaseOutput} onChange={(e) => setTestCaseOutput(e.target.value)} placeholder="Enter expected output" />
      </Form.Item>
      <Form.Item label="Agent ID">
        <Input type='number' value={testCaseAgentId} onChange={(e) => setTestCaseAgentId(e.target.value)} />
      </Form.Item>
      <Form.Item label="Model">
        <div
          onClick={() => setIsModelDropdownVisible(!isModelDropdownVisible)}
          style={{ width: "100%", padding: '8px', borderRadius: '5px', color: 'black', cursor: 'pointer', border: "2px dotted #8C2BE4" }}
        >
          {testCaseExecuteProvider.toUpperCase()}/{testCaseExecuteModel.toUpperCase()}
        </div>
        {isModelDropdownVisible && (
          <div style={{ position: "absolute", maxHeight: "300px", overflow: "auto", width: '100%', backgroundColor: '#333333', borderRadius: '5px', zIndex: 100, marginTop: '8px' }}>
            {Object.entries(LLMs).map(([provider, models]) => (
              <div key={provider}>
                <div style={{ padding: '10px', fontWeight: 'bold', color: '#8C2BE4' }}>
                  {provider.toUpperCase()} MODELS
                </div>
                {models.map(model => (
                  <div
                    key={model.value}
                    onClick={() => handleTestCaseModelSelect(provider, model.value)}
                    style={{
                      padding: '10px 20px',
                      cursor: 'pointer',
                      color: 'white',
                      backgroundColor: model.value === testCaseExecuteModel ? '#8C2BE4' : 'transparent',
                    }}
                  >
                    {model.label}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">Submit</Button>
      </Form.Item>
    </Form>
  );
};

export default TestCaseForm;
